const TemplatePositionIcon = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.151 19.3019L20.2372 19.306C20.6655 19.3493 21 19.7112 21 20.151C20.9999 20.5906 20.6655 20.9526 20.2372 20.9959L20.151 21H3.84905C3.38019 21 3.00009 20.6198 3 20.151C3 19.682 3.38013 19.3019 3.84905 19.3019H20.151ZM19.3019 10.4715C19.3018 9.81506 18.7693 9.28329 18.1129 9.28329H5.8871C5.23067 9.28329 4.69819 9.81506 4.6981 10.4715V13.5285L4.7039 13.6496C4.76469 14.2491 5.27158 14.7167 5.8871 14.7167H18.1129C18.7693 14.7167 19.3017 14.1849 19.3019 13.5285V10.4715ZM20.151 3L20.2372 3.00415C20.6655 3.04743 21 3.40929 21 3.84905C21 4.28881 20.6655 4.65067 20.2372 4.69395L20.151 4.6981H3.84905C3.38013 4.6981 3 4.31797 3 3.84905C3 3.38013 3.38013 3 3.84905 3H20.151ZM21 13.5285C20.9998 15.1227 19.7071 16.4148 18.1129 16.4148H5.8871C4.34268 16.4148 3.08157 15.2021 3.00415 13.677L3 13.5285V10.4715C3.00009 8.87722 4.29284 7.5852 5.8871 7.5852H18.1129C19.7072 7.5852 20.9999 8.87722 21 10.4715V13.5285Z"
      fill="#090914"
    />
  </svg>
);

export default TemplatePositionIcon;
